var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.mobile ? 'd-flex justify-end mt-2' : 'd-flex justify-end mt-1'},[(!_vm.mobile)?_c('h1',{staticClass:"app-title mt-2 mr-2"},[_vm._v(" "+_vm._s(_vm.informationRow)+" ")]):_vm._e(),_c('div',{class:`${_vm.classText} d-flex`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }